import { type DependencyList, useEffect, useRef } from 'react';

/**
 * Runs an effect only on updates (skips initial render).
 *
 * @param effect Effect callback to run after updates
 * @param deps Dependency array
 */
const useEffectAfterMount = (
  callback: () => void | (() => void),
  deps: DependencyList
) => {
  const hasMounted = useRef(false);

  useEffect(() => {
    if (hasMounted.current) {
      return callback();
    }

    hasMounted.current = true;

    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

// eslint-disable-next-line import/prefer-default-export
export { useEffectAfterMount };
